// import React, { useContext, useEffect, useState, useRef } from "react";
// import "./BudgetEstimation.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import Application from "../../../StateContext/Application.js";
// import { apiurl } from "../../../../../path.js";
// import Select from "react-select";
// import {
//   ProjectCreation64,
//   BudgetHeadCreationBlue32,
//   Cancel32,
//   DeleteRed32,
//   EditBlueBlue32,
//   submit,
//   Tax32,
//   UpdateWhite32,
//   EditIcon,
//   DeleteIcon,
//   Edit32WHITE,
//   Delete32WHITE,
// } from "../../../../../public/LoginImages/importimages";
// const BudgetEstimation = ({
//   isEdit = false,
//   BudgetEstimationData,
//   onSuccess,
//   onCancle,
// }) => {
//   const operation = useContext(Application);
//   const [totalEstimationAmount, setTotalEstimationAmount] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//  const [errors, setErrors] = useState({});//09-10 error msg
//   const { GetProjectInfo, GetBudgetHeadInfo, BudgetEstimation } = operation;

//   const [projectId, setProjectId] = useState([]);
//   const [HeadId, setHeadID] = useState([]);
//   const [allHeadId, setAllHeadID] = useState([]);
//   const [editIndex, setEditIndex] = useState(null);
//   // const [isEditing, setIsEditing] = useState(false);
//   const [IsEdit, setIsEdit] = useState(null);
//   const [EditBudgetEstimateId, setEditBudgetEstimateId] = useState(null);
//   const [indexofediting, setIndexofEditing] = useState(null);
//   const [relatedHeadID, setRelatedHeadID] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [remainingAmount, setRemainingAmount] = useState(0); // State for remaining amount
//   const [tableData, setTableData] = useState([]);
//   const [dynamicRemainingProjectCost, setDynamicRemainingProjectCost] =
//     useState(0);

//   const [data, setData] = useState({
//     ProjectID: "",
//     ProjectName: "",
//     ProjectCost: "0",
//     piu: "",
//     GRCopy: "",
//     FinancialYear: "",
//     BudgetHeadID: "",
//     BudgetHeadName: "",
//     BudgetHeadType: "",
//     ObjectCode: "",
//     EsitmateAmount: null,
//     UsedAmount: 0,
//   });

//   useEffect(() => {
//     if (isEdit && BudgetEstimationData) {
//       console.log("BudgetEstimationData for eidt:", BudgetEstimationData);

//       setData({
//         ProjectID: BudgetEstimationData.ProjectID,
//         ProjectName: BudgetEstimationData.ProjectName || "",
//         ProjectCost: BudgetEstimationData.ProjectCost || "",
//         piu: BudgetEstimationData.piu || "",
//         Date: BudgetEstimationData.Date
//           ? BudgetEstimationData.Date.slice(0, 16)
//           : "",
//         GRCopy: BudgetEstimationData.GRCopy || "",
//         FinancialYear: BudgetEstimationData.Year || "",
//         BudgetHeadID: BudgetEstimationData.BudgetID,
//         BudgetHeadName: BudgetEstimationData.BudgetHead || "",
//         BudgetHeadType: BudgetEstimationData.BudgetHeadType || "",
//         ObjectCode: BudgetEstimationData.ObjectCode || "",
//         EsitmateAmount: BudgetEstimationData.EsitmateAmount || "",
//         UsedAmount: BudgetEstimationData.UsedAmount || "",
//       });
//     }
//   }, [isEdit, BudgetEstimationData]);
//   // useEffect(() => {
//   //   //remove the && HeadId.length > 0 for head fetch according project -08/08
//   //   if (isEdit && BudgetEstimationData && projectId.length > 0) {
//   //     HeadIDFetchOperation(BudgetEstimationData.ProjectID, "ProjectId");
//   //     HeadIDFetchOperation(BudgetEstimationData.BudgetID, "HeadID");
//   //   }
//   // }, [projectId, HeadId, BudgetEstimationData]);

//   useEffect(() => {
//     if (
//       isEdit &&
//       BudgetEstimationData &&
//       projectId.length > 0 &&
//       allHeadId.length > 0
//     ) {
//       HeadIDFetchOperation(BudgetEstimationData.ProjectID, "ProjectId");

//       HeadIDFetchOperation(BudgetEstimationData.BudgetID, "HeadID");
//     }
//   }, [isEdit, BudgetEstimationData, projectId.length, allHeadId.length]);
//   // const HandleChangeData = (e) => {
//   //   const { name, value } = e.target;
//   //   if (name === "EsitmateAmount") {
//   //     if (parseFloat(value) < 0) {
//   //       alert("Estimate Amount cannot be negative.");
//   //       return;
//   //     }
//   //     if (parseFloat(value) > dynamicRemainingProjectCost) {
//   //       alert("Estimate Amount cannot exceed the Remaining Project Cost.");
//   //       return;
//   //     }
//   //   }
//   //   // setData({ ...data, [name]: value });
//   //   setData((prev) => ({
//   //     ...prev,
//   //     [name]: value,
//   //   }));
//   // };


// // 09-10 error msg 
//  const HandleChangeData = (e) => {
//   const { name, value } = e.target;
 
//   if (name === "EsitmateAmount") {
//     if (parseFloat(value) < 0) {
//       setErrors((prev) => ({
//         ...prev,
//         EsitmateAmount: "Estimate Amount cannot be negative",
//       }));
//       return;
//     }
 
//     if (
//       parseFloat(value) > dynamicRemainingProjectCost &&
//       value !== ""
//     ) {
//       setErrors((prev) => ({
//         ...prev,
//         EsitmateAmount:
//           "Estimate Amount cannot exceed the Remaining Project Cost",
//       }));
//       return;
//     }
//   }
 
//   setData((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
 
//   setErrors((prev) => ({
//     ...prev,
//     [name]: "",
//   }));
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

// // 09-10 erroor msg
// const newErrors = {};
 
//   if (!data.FinancialYear || data.FinancialYear === "null") {
//     newErrors.FinancialYear = "Financial Year is required";
//   }
 
//   if (!data.BudgetHeadID || data.BudgetHeadID === "null") {
//     newErrors.BudgetHeadID = "Budget Head is required";
//   }
 
//   if (!data.ProjectID || data.ProjectID === "null") {
//     newErrors.ProjectID = "Project Name is required";
//   }
 
//   if (!data.ProjectCost || Number(data.ProjectCost) <= 0) {
//     newErrors.ProjectCost = "Project Cost is required";
//   }
 
//   if (!data.piu || data.piu.trim() === "") {
//     newErrors.piu = "Implementing Agency is required";
//   }
 
//   if (!data.GRCopy || data.GRCopy.trim() === "") {
//     newErrors.GRCopy = "Project GR Copy is required";
//   }
 
//  //10/10
//    if (tableData.length === 0 && !(Number(data.EsitmateAmount) > 0)) {
//     newErrors.EsitmateAmount = "Estimate Amount is required";
//   }
 
//   if (
//     dynamicRemainingProjectCost === null ||
//     dynamicRemainingProjectCost === undefined
//   ) {
//     newErrors.RemainingProjectCost = "Remaining Project Cost is required";
//   }
 
//   if (Object.keys(newErrors).length > 0) {
//     setErrors(newErrors);
//     return;
//   }
 
//   setErrors({});
//   // setLoading(true);
 

//     if (!tableData || tableData.length === 0) {
//       alert("Please Add Your Estimate Amount.");
//       return;
//     }

//     // ✅ Make sure every row has a Budget Head
//     const missingBudgetHead = tableData.some((item) => !item.BudgetHead);

//     if (missingBudgetHead) {
//       alert("Please select Budget Head.");
//       return;
//     }

//     // setLoading(true);
//     setLoading(true);

//     try {
//       const payload = {
//         ...(isEdit
//           ? {
//               type: "updateBudgetEstimationData",
//               ID: BudgetEstimationData.ID,
//             }
//           : {
//               type: "createBudgetEstimationData",
//             }),
//         ProjectID: data.ProjectID, // selected project ID
//         ProjectName: data.ProjectName,
//         FinancialYear: data.FinancialYear,
//         ObjectCode: data.ObjectCode,
//         Estimations: tableData.map((item) => ({
//           BudgetID: item.BudgetID,
//           BudgetHead: item.BudgetHead,
//           ObjectCode: data.ObjectCode,
//           Amount: item.amount,
//           Date: item.currentDate,
//         })),
//       };

//       const res = await BudgetEstimation(payload); // ✅ send correct payload
//       console.log(res);
//       // alert(res.message);
//       // 10-10
//         alert(isEdit ? "Updated successfully" : res?.message || "Submitted successfully");
//       await FetchData();
//       setTableData([]);
//       window.location.reload();
//       setData((prev) => ({ ...prev, EsitmateAmount: null }));
//       setRemainingAmount(0);
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const FetchData = async () => {
//     try {
//       let res = await GetProjectInfo("null", "all");
//       let res1 = await GetBudgetHeadInfo("null", "all");
//       const projects = await GetProjectInfo("null", "all");

//       const heads = await GetBudgetHeadInfo("null", "all");
//       setProjectId(res);
//       setAllHeadID(res1);
//       setHeadID(res1);
//       setProjectId(projects || []);

//       setAllHeadID(heads || []);

//       setHeadID(heads || []);
//       setFilteredProjects(projects || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   useEffect(() => {
//     // initial remaining = ProjectCost - UsedAmount from DB
//     const initialRemainingCost =
//       parseFloat(data.ProjectCost || 0) - parseFloat(data.UsedAmount || 0);

//     // total of all estimated amounts in the table for this project
//     const totalAmountInTableForProject = tableData.reduce((total, item) => {
//       if (item.projectId === data.ProjectID) {
//         return total + Number(item.amount);
//       }

//       return total;
//     }, 0);
//     console.log("totalamountestimate", totalAmountInTableForProject); //this is we will show in workorder
//     // update remaining project cost
//     setDynamicRemainingProjectCost(
//       initialRemainingCost - totalAmountInTableForProject,
//     );

//     // update total estimation amount
//     setTotalEstimationAmount(
//       totalAmountInTableForProject + (data.UsedAmount || 0),
//     );
//   }, [tableData, data.ProjectID, data.ProjectCost, data.UsedAmount]);

//   const HeadIDFetchOperation = async (ID, IDtype) => {
//     try {
//       console.log(ID);
//       if (IDtype == "ProjectId") {
//         let res1 = await GetProjectInfo(ID, "id");
//         if (!res1 || res1.length === 0) {
//           setHeadID([]);
//           return;
//         }
//         console.log("Project ID ingo :: ", res1);
//         let projectData = res1[0];
//         const projectHeadIDs = [
//           ...new Set(
//             res1
//               .map(
//                 (item) =>
//                   item.ProjectHeadID || item.BudgetHeadID || item.HeadID,
//               )
//               .filter(Boolean)
//               .map((id) => String(id)),
//           ),
//         ];

//         const relatedHeads = allHeadId.filter((head) =>
//           projectHeadIDs.includes(String(head.HeadID)),
//         );

//         console.log("Project Head IDs:", projectHeadIDs);
//         console.log("Related Heads:", relatedHeads);

//         setHeadID(relatedHeads);
//         // const projectHeadNames = [
//         //   ...new Set(
//         //     res1
//         //       .map((item) => item.BudgetHead)
//         //       .filter(Boolean)
//         //       .map((name) => name.trim().toLowerCase()),
//         //   ),
//         // ];
//         // const relatedHeads = allHeadId.filter((head) =>
//         //   projectHeadNames.includes(
//         //     String(head.HeadName || "")
//         //       .trim()
//         //       .toLowerCase(),
//         //   ),
//         // );

//         console.log("Related Heads:", relatedHeads);

//         // setHeadID(relatedHeads);
//         console.log("project data i sleected ", projectData);

//         // let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
//         // console.log("Head related to project ", apple)
//         // setRelatedHeadID(apple);

//         setData((prev) => ({
//           ...prev,
//           FinancialYear: projectData.FinancialYear || prev.FinancialYear,
//           ProjectName: projectData.ProjectName || " ",
//           ProjectID: projectData.ProjectId || " ",
//           ProjectCost: projectData.ProjectCost || " ",
//           piu: projectData.PIU || " ",
//           GRCopy: projectData.GRCopy || " ",
//           UsedAmount: projectData.UsedAmount || 0,
//         }));
//       } else if (IDtype == "HeadID") {
//         let res1 = await GetBudgetHeadInfo(ID, "id");
//         if (!res1 || res1.length === 0) {
//           console.log("Budget Head not found");
//           return;
//         }
//         console.log("Head ID info ", res1);
//         let HeadData = res1[0];
//         setData((prev) => ({
//           ...prev,
//           BudgetHeadID: HeadData.HeadID || " ",
//           BudgetHeadName: HeadData.HeadName || " ",
//           BudgetHeadType: HeadData.HeadType || " ",
//         }));
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchData();
//   }, []);

//   const AddinTableOperation = (e) => {
//     e.preventDefault();

//     // if (!tableData || tableData.length === 0) {
//     //   alert("Please select Budget Head.");
//     //   return;
//     // }

//     // // ✅ Make sure every row has a Budget Head
//     // const missingBudgetHead = tableData.some((item) => !item.BudgetHead);

//     // if (missingBudgetHead) {
//     //   alert("Please select Budget Head.");
//     //   return;
//     // }

//     if (!data.BudgetHeadID) {
//       alert("Please select Budget Head.");
//       return;
//     }

//     // setLoading(true);
//     const newAmount = parseFloat(data.EsitmateAmount);

//     if (!newAmount || newAmount < 0) {
//       alert("Please enter a valid Estimate Amount.");
//       return;
//     }

//     if (newAmount > dynamicRemainingProjectCost) {
//       alert(
//         "Adding this amount would exceed the Remaining Project Cost. Please adjust your estimate.",
//       );
//       return;
//     }

//     let obj = {
//       projectId: data.ProjectID,
//       projectName: data.ProjectName,
//       year: data.FinancialYear,
//       BudgetID: data.BudgetHeadID,
//       BudgetHead: data.BudgetHeadName,
//       amount: newAmount,
//       currentDate: new Date().toISOString(),
//     };

//     setTableData((prev) => [...prev, obj]);

//     // clear estimate amount for next entry
//     setData((prev) => ({ ...prev, EsitmateAmount: "" }));
//   };

//   console.log("table Data :: ", tableData);

//   const handleEdit = (e, index) => {
//     e.preventDefault();
//     const item = tableData[index];
//     console.log("table i selected :: ", item);
//     setEditIndex(item);
//     setIndexofEditing(index);
//   };

//   const handleDelete = (e, index) => {
//     e.preventDefault();
//     const updated = tableData.filter((_, i) => i !== index);
//     setTableData(updated);
//   };

//   const handelchangeTablre = (e) => {
//     e.preventDefault();
//     const updatedData = [...tableData];
//     updatedData[indexofediting] = editIndex;
//     setTableData(updatedData);
//     console.log("Editted Index :: ", editIndex);
//     setEditIndex(null);
//     setIndexofEditing(null);
//   };

//   const handleYearChange = (e) => {
//     const year = e.target.value;
//     setData({ ...data, FinancialYear: year, ProjectID: "", ProjectName: "" });
//     setFilteredProjects([]); // reset
//   };

//   // const handleHeadChange = async (e) => {
//   //   const headID = e.target.value;
//   //   console.log("Head ID :: ", headID);

//   //   if (headID !== "null" && data.FinancialYear) {

//   //     const res = await GetProjectInfo("null", "all");
//   //     console.log("All projects:", res);

//   //     const related = res.filter(
//   //       (p) =>
//   //         p.FinancialYear === data.FinancialYear &&
//   //         HeadId.some((h) => h.HeadID == headID)
//   //     );
//   //     console.log("Filtered Projects for Budget Head:", related);
//   //     setFilteredProjects(related);

//   //     let res1 = await GetBudgetHeadInfo(headID, "id");
//   //     console.log("Head ID info ", res1);

//   //     let selectedHeadID = headID; // ✅ Temporary variable to send immediately

//   //     if (res1 && res1.length > 0) {
//   //       const HeadData = res1[0];

//   //       // Update local state (optional for UI)
//   //       setData((prev) => ({
//   //         ...prev,
//   //         BudgetHeadID: headID,
//   //         BudgetHeadName: HeadData.HeadName,
//   //         ObjectCode: HeadData.objectCode,
//   //       }));
//   //     }
//   //   } else {
//   //     // If no head selected
//   //     setFilteredProjects([]);
//   //     setData((prev) => ({ ...prev, BudgetHeadID: "", BudgetHeadName: "" }));
//   //   }
//   // };

//   //change data according prpject -08/08
//   // const handleHeadChange = async (e) => {
//   //   const headID = e.target.value;

//   //   if (headID !== "null") {
//   //     let res1 = await GetBudgetHeadInfo(headID, "id");

//   //     if (res1 && res1.length > 0) {
//   //       const HeadData = res1[0];

//   //       setData((prev) => ({
//   //         ...prev,
//   //         BudgetHeadID: headID,
//   //         BudgetHeadName: HeadData.HeadName,
//   //         ObjectCode: HeadData.objectCode,
//   //       }));
//   //     }
//   //   } else {
//   //     setData((prev) => ({
//   //       ...prev,
//   //       BudgetHeadID: "",
//   //       BudgetHeadName: "",
//   //       ObjectCode: ""
//   //     }));
//   //   }
//   // };

//   //-=====upadte on 27-08/2026
//   // const handleHeadChange = async (e) => {
//   //   const headID = e.target.value;
//   //   // Clear previous project
//   //   setData((prev) => ({
//   //     ...prev,
//   //     BudgetHeadID: headID,
//   //     BudgetHeadName: "",
//   //     BudgetHeadType: "",
//   //     ObjectCode: "",
//   //     ProjectID: "",
//   //     ProjectName: "",
//   //     ProjectCost: "",
//   //     piu: "",
//   //     GRCopy: "",
//   //     UsedAmount: 0,
//   //   }));

//   //   if (!headID || headID === "null") {
//   //     setFilteredProjects(projectId || []);
//   //     setHeadID(allHeadId || []);
//   //     return;
//   //   }

//   //   // setFilteredProjects([]);
//   //   // if (!headID || headID === "null") {
//   //   //   return;
//   //   // }
//   //   try {
//   //     // 1. GET SELECTED HEAD
//   //     const headRes = await GetBudgetHeadInfo(headID, "id");
//   //     if (!headRes || headRes.length === 0) {
//   //       setFilteredProjects([]);
//   //       console.log("Budget Head not found");
//   //       return;
//   //     }
//   //     const HeadData = headRes[0];
//   //     console.log("SELECTED HEAD:", HeadData);
//   //     // const selectedHeadName = String(HeadData.HeadName || "")
//   //     //   .trim()
//   //     //   .toLowerCase();
//   //     // Set selected head details
//   //     setData((prev) => ({
//   //       ...prev,
//   //       BudgetHeadID: HeadData.HeadID || headID,
//   //       BudgetHeadName: HeadData.HeadName || "",
//   //       BudgetHeadType: HeadData.HeadType || "",
//   //       ObjectCode: HeadData.objectCode || "",
//   //     }));
//   //     // 2. GET ALL BUDGET PROJECTS
//   //     const projectRes = await GetProjectInfo("null", "BudgetProjects");
//   //     console.log("ALL PROJECTS:", projectRes);
//   //     if (!projectRes || projectRes.length === 0) {
//   //       setFilteredProjects([]);
//   //       return;
//   //     }
//   //     // 3. CHECK EVERY PROJECT
//   //     const matchedProjects = [];
//   //     for (const project of projectRes) {
//   //       if (!project.ProjectId) {
//   //         continue;
//   //       }
//   //       const projectDetails = await GetProjectInfo(project.ProjectId, "id");
//   //       console.log("PROJECT DETAILS:", project.ProjectName, projectDetails);
//   //       if (!projectDetails || projectDetails.length === 0) {
//   //         continue;
//   //       }
//   //       // 4. MATCH PROJECT HEAD ID
//   //       const matched = projectDetails.some((item) => {
//   //         const projectHeadID = String(item.ProjectHeadID || item.HeadID || "");
//   //         console.log("Checking:", project.ProjectName, {
//   //           projectHeadID,
//   //           selectedHeadID: String(headID),
//   //         });
//   //         return projectHeadID === String(headID);
//   //       });
//   //       // 5. ADD MATCHING PROJECT
//   //       if (matched) {
//   //         if (
//   //           !data.FinancialYear ||
//   //           project.FinancialYear === data.FinancialYear
//   //         ) {
//   //           matchedProjects.push(project);
//   //         }
//   //       }
//   //     }
//   //     // 6. REMOVE DUPLICATE
//   //     const uniqueProjects = [
//   //       ...new Map(
//   //         matchedProjects.map((project) => [project.ProjectId, project]),
//   //       ).values(),
//   //     ];
//   //     // 7. SHOW PROJECTS
//   //     console.log("ALL PROJECTS MATCHING HEAD:", uniqueProjects);
//   //     setFilteredProjects(uniqueProjects);
//   //   } catch (error) {
//   //     console.error("Error fetching projects by Budget Head:", error);
//   //     setFilteredProjects([]);
//   //   }
//   // };
//   const handleHeadChange = async (e) => {
//     const headID = e.target.value;

//     console.log("SELECTED HEAD ID:", headID);

//     // ================= CLEAR BUDGET HEAD =================
//     if (!headID || headID === "null") {
//       setData((prev) => ({
//         ...prev,
//         BudgetHeadID: "",
//         BudgetHeadName: "",
//         BudgetHeadType: "",
//         ObjectCode: "",
//         ProjectID: "",
//         ProjectName: "",
//         ProjectCost: "",
//         piu: "",
//         GRCopy: "",
//         UsedAmount: 0,
//       }));

//       setFilteredProjects(projectId || []);
//       setHeadID(allHeadId || []);

//       return;
//     }

//     try {
//       // =====================================================
//       // 1. GET SELECTED BUDGET HEAD
//       // =====================================================
//       const headRes = await GetBudgetHeadInfo(headID, "id");

//       if (!headRes || headRes.length === 0) {
//         console.log("Budget Head not found");

//         setFilteredProjects([]);

//         return;
//       }

//       const HeadData = headRes[0];

//       console.log("SELECTED HEAD:", HeadData);

//       // =====================================================
//       // 2. SET SELECTED BUDGET HEAD DATA
//       // =====================================================
//       setData((prev) => ({
//         ...prev,

//         BudgetHeadID: HeadData.HeadID || headID,

//         BudgetHeadName: HeadData.HeadName || "",

//         BudgetHeadType: HeadData.HeadType || "",

//         ObjectCode: HeadData.objectCode || "",

//         // Clear previous project
//         ProjectID: "",
//         ProjectName: "",
//         ProjectCost: "",
//         piu: "",
//         GRCopy: "",
//         UsedAmount: 0,
//       }));

//       // Clear old table rows when Budget Head changes
//       setTableData([]);

//       // =====================================================
//       // 3. GET ALL BUDGET PROJECTS
//       // =====================================================
//       const projectRes = await GetProjectInfo("null", "BudgetProjects");

//       console.log("ALL PROJECTS:", projectRes);

//       if (!projectRes || projectRes.length === 0) {
//         setFilteredProjects([]);
//         return;
//       }

//       // =====================================================
//       // 4. CHECK EVERY PROJECT
//       // =====================================================
//       const matchedProjects = [];

//       for (const project of projectRes) {
//         if (!project.ProjectId) {
//           continue;
//         }

//         // Get complete project details
//         const projectDetails = await GetProjectInfo(project.ProjectId, "id");

//         console.log("PROJECT DETAILS:", project.ProjectName, projectDetails);

//         if (!projectDetails || projectDetails.length === 0) {
//           continue;
//         }

//         // ===================================================
//         // 5. CHECK PROJECT'S BUDGET HEAD ID
//         // ===================================================
//         const matched = projectDetails.some((item) => {
//           const projectHeadID = String(
//             item.ProjectHeadID || item.BudgetHeadID || item.HeadID || "",
//           );

//           console.log("Checking:", project.ProjectName, {
//             projectHeadID,
//             selectedHeadID: String(headID),
//           });

//           return projectHeadID === String(headID);
//         });

//         // ===================================================
//         // 6. ADD MATCHING PROJECT
//         // ===================================================
//         if (matched) {
//           // Financial year filtering
//           if (
//             !data.FinancialYear ||
//             project.FinancialYear === data.FinancialYear
//           ) {
//             matchedProjects.push(project);
//           }
//         }
//       }

//       // =====================================================
//       // 7. REMOVE DUPLICATE PROJECTS
//       // =====================================================
//       const uniqueProjects = [
//         ...new Map(
//           matchedProjects.map((project) => [project.ProjectId, project]),
//         ).values(),
//       ];

//       console.log("ALL PROJECTS MATCHING HEAD:", uniqueProjects);

//       // =====================================================
//       // 8. SHOW FILTERED PROJECTS
//       // =====================================================
//       setFilteredProjects(uniqueProjects);
//     } catch (error) {
//       console.error("Error fetching projects by Budget Head:", error);

//       setFilteredProjects([]);
//     }
//   };

//   const rowStyle = {
//     width: "100%",

//     display: "flex",
//     alignItems: "center",

//     marginBottom: "12px",
//   };

//  //30/10
//   const labelStyle = {
//     width: "28%",
//     fontSize: "14px",
//     fontWeight: "700",
//    whiteSpace:"nowrap",
//     color: "#111111",

//     flexShrink: 0,
//   };

//   // 09-10
//   const inputStyle = {
//     width: "95%",
//     height: "38px",
 
//     padding: "8px 12px",
 
//     border: "1px solid #999999",
//     borderRadius: "6px",
 
//     backgroundColor: "#ffffff",
 
//     fontSize: "12px",
 
//     boxSizing: "border-box",
 
//     outline: "none"
//   };
 
//   // -09-10 error msg
//  const disabledInputStyle = {
//   width: "95%",
//   minHeight: "38px",
//   display: "flex",
//   alignItems: "center",
//   padding: "8px 12px",
//   border: "1px solid #999999",
//   borderRadius: "6px",
//   backgroundColor: "#C8D9E8",
//   color: "#333333",
//   fontSize: "11px",
//   boxSizing: "border-box",
//   overflow: "hidden"
// };
// const errorStyle = {
//   color: "#dc3545",
//   fontSize: "12px",
//   marginTop: "3px",
//   display: "block",
//   fontWeight: "500",
//   lineHeight: "14px",
//   height: "14px",       // important
//   visibility: "visible",
// };

  
//   return (
//     <>
//       <div
//         style={{
//           width: "100%",
//           height: "90vh",
//           minHeight: "calc(100vh - 80px)",
//           backgroundColor: "#ffffff",
//           // padding: "15px 25px 30px",
//           padding:"40px",
//           boxSizing: "border-box",
//           fontFamily: "Inter, sans-serif",
//           overflowY: "auto",
//           overflowX: "hidden",
//         }}
//       >
//         {/* ================= PAGE TITLE ================= */}
//         <div
//           style={{
//              display: "flex",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           background: "transparent",
//           padding: "0",
//           // marginRight: "20px",
//           // marginLeft: "-30px",
//           boxShadow: "none",
//           width: "100%",
//           marginBottom: "18px",
//           }}
//         >
//           <img
//             src={ProjectCreation64}
//             alt="Budget Estimation"
//             style={{
//               width: "24px",
//               height: "24px",
//               objectFit: "contain",
//             }}
//           />

//           <h5
//             style={{
//                margin: 0,
//             color: "black",
//             fontWeight: 700,
//             fontSize: "22px",
//             lineHeight: "1.2",
//             }}
//           >
//             {isEdit ? "Update Budget Estimate" : "Add Budget Estimation"}
//           </h5>
//         </div>

//         {/* ================= MAIN FORM ================= */}
//       <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "1000px", margin: "0 auto", width:"100%" }}>
//         <form
//           onSubmit={handleSubmit}
//             style={{
//         backgroundColor: "#EEF2F8",
//         border: "1px solid #dde3ee",
//         borderRadius: "10px",
//         padding: "25px 28px",
       
//         gap: "18px 24px",
//       }}
//         >
//           {/* ================= FINANCIAL YEAR ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Financial Year</label>

//             <Select
//               options={[
//                 {
//                   value: "2024-2025",
//                   label: "2024 - 2025",
//                 },
//                 {
//                   value: "2025-2026",
//                   label: "2025 - 2026",
//                 },
//                 {
//                   value: "2026-2027",
//                   label: "2026 - 2027",
//                 },
//               ]}
//               value={
//                 data.FinancialYear
//                   ? {
//                       value: data.FinancialYear,
//                       label: data.FinancialYear.replace("-", " - "),
//                     }
//                   : null
//               }
//               onChange={(selected) =>
//                 HandleChangeData({
//                   target: {
//                     name: "FinancialYear",
//                     value: selected ? selected.value : "",
//                   },
//                 })
//               }
//               placeholder="Choose Financial Year"
//               isSearchable
//               isClearable
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                   minHeight: "40px",
//   height: "40px",
//   borderRadius: "10px",
//   border: "1px solid #c7c0c0",
//   fontSize: "12px",
//   width: "100%",
//   boxShadow: "none",
//                 }),
//                 valueContainer: (base) => ({
//                   ...base,
//                   height: "38px",
//                   padding: "0 12px",
//                 }),
//                 indicatorsContainer: (base) => ({
//                   ...base,
//                   height: "38px",
//                 }),
//                 singleValue: (base) => ({
//                   ...base,
//                   fontSize: "13px",
//                 }),
//                 option: (base) => ({
//                   ...base,
//                   fontSize: "13px",
//                 }),
//               }}
//             />
//             {errors.FinancialYear && (
//       <span style={errorStyle}>
//         {errors.FinancialYear}
//       </span>
//     )}
//           </div>

//           {/* ================= BUDGET HEAD ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>
//               Budget Head <span style={{ color: "red" }}>*</span>
//             </label>

//             <Select
//               options={HeadId.map((val) => ({
//                 value: val.HeadID,
//                 label: val.HeadName || "",
//               }))}
//               value={
//                 HeadId.map((val) => ({
//                   value: val.HeadID,
//                   label: val.HeadName || "",
//                 })).find(
//                   (option) =>
//                     String(option.value) === String(data.BudgetHeadID),
//                 ) || null
//               }
//               onChange={(selected) => {
//                 handleHeadChange({
//                   target: {
//                     name: "BudgetHeadID",
//                     value: selected ? selected.value : "",
//                   },
//                 });
//               }}
//               placeholder="Choose Budget Head"
//               isSearchable
//               isClearable
//               noOptionsMessage={() => "No budget head found"}
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                    minHeight: "40px",
//   height: "40px",
//   borderRadius: "10px",
//   border: "1px solid #c7c0c0",
//   fontSize: "12px",
//   width: "100%",
//   boxShadow: "none",
//                 }),
//                 valueContainer: (base) => ({
//                   ...base,
//                   height: "38px",
//                   padding: "0 12px",
//                 }),
//                 indicatorsContainer: (base) => ({
//                   ...base,
//                   height: "38px",
//                 }),
//                 singleValue: (base) => ({
//                   ...base,
//                   fontSize: "13px",
//                 }),
//                 option: (base) => ({
//                   ...base,
//                   fontSize: "13px",
//                 }),
//               }}
//             />  {errors.BudgetHeadID && (
//     <span style={errorStyle}>
//       {errors.BudgetHeadID}
//     </span>
//   )}
 
//           </div>

//           {/* ================= PROJECT NAME ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Project Name</label>

//             {!isEdit ? (
//               <Select
//                 options={filteredProjects.map((val) => ({
//                   value: val.ProjectId,
//                   label: val.ProjectName,
//                 }))}
//                 value={
//                   filteredProjects
//                     .map((val) => ({
//                       value: val.ProjectId,
//                       label: val.ProjectName,
//                     }))
//                     .find(
//                       (option) =>
//                         String(option.value) === String(data.ProjectID),
//                     ) || null
//                 }
//                 onChange={async (selected) => {
//                   const selectedProjectID = selected ? selected.value : "";

//                   /* ================= PROJECT CLEARED ================= */
//                   if (!selectedProjectID) {
//                     setData((prev) => ({
//                       ...prev,
//                       ProjectID: "",
//                       ProjectName: "",
//                       ProjectCost: "",
//                       piu: "",
//                       GRCopy: "",
//                       UsedAmount: 0,
//                       BudgetHeadID: "",
//                       BudgetHeadName: "",
//                       BudgetHeadType: "",
//                       ObjectCode: "",
//                     }));

//                     setFilteredProjects(projectId || []);
//                     setHeadID(allHeadId || []);

//                     return;
//                   }

//                   /* ================= PROJECT SELECTED ================= */
//                   try {
//                     const projectDetails = await GetProjectInfo(
//                       selectedProjectID,
//                       "id",
//                     );

//                     if (!projectDetails || projectDetails.length === 0) {
//                       return;
//                     }

//                     const projectData = projectDetails[0];

//                     console.log("Selected Project Details:", projectData);

//                     /* ================= FIND PROJECT HEAD ================= */
//                     const projectHeadID =
//                       projectData.ProjectHeadID ||
//                       projectData.BudgetHeadID ||
//                       projectData.HeadID;

//                     let relatedHeads = [];

//                     if (projectHeadID) {
//                       relatedHeads = allHeadId.filter(
//                         (head) => String(head.HeadID) === String(projectHeadID),
//                       );
//                     }

//                     console.log(
//                       "Heads related to selected project:",
//                       relatedHeads,
//                     );

//                     setHeadID(relatedHeads);

//                     /* ================= SET PROJECT DATA ================= */
//                     setData((prev) => ({
//                       ...prev,

//                       ProjectID: projectData.ProjectId || selectedProjectID,

//                       ProjectName: projectData.ProjectName || "",

//                       FinancialYear:
//                         projectData.FinancialYear || prev.FinancialYear,

//                       ProjectCost: projectData.ProjectCost || 0,

//                       piu: projectData.PIU || "",

//                       GRCopy: projectData.GRCopy || "",

//                       UsedAmount: projectData.UsedAmount || 0,

//                       BudgetHeadID: projectHeadID || "",

//                       BudgetHeadName:
//                         relatedHeads.length > 0 ? relatedHeads[0].HeadName : "",

//                       BudgetHeadType:
//                         relatedHeads.length > 0 ? relatedHeads[0].HeadType : "",

//                       ObjectCode:
//                         relatedHeads.length > 0
//                           ? relatedHeads[0].objectCode
//                           : "",
//                     }));

//                     HeadIDFetchOperation(selectedProjectID, "ProjectId");
//                   } catch (error) {
//                     console.error("Error fetching selected project:", error);
//                   }
//                 }}
//                 placeholder="Choose Project"
//                 isSearchable
//                 isClearable
//                 noOptionsMessage={() => "No project found"}
//                 styles={{
//                   control: (base) => ({
//                     ...base,
//                     minHeight: "40px",
//   height: "40px",
//   borderRadius: "10px",
//   border: "1px solid #c7c0c0",
//   fontSize: "12px",
//   width: "100%",
//   boxShadow: "none",
//                   }),
//                   valueContainer: (base) => ({
//                     ...base,
//                     height: "38px",
//                     padding: "0 12px",
//                   }),
//                   indicatorsContainer: (base) => ({
//                     ...base,
//                     height: "38px",
//                   }),
//                   singleValue: (base) => ({
//                     ...base,
//                     fontSize: "13px",
//                   }),
//                   option: (base) => ({
//                     ...base,
//                     fontSize: "13px",
//                   }),
//                 }}
//               />
 
//             ) : (
//               <input
//                 type="text"
//                 value={data.ProjectName || ""}
//                 readOnly
//                 style={{
//                   ...inputStyle,
//                   width: "100%",
//                 }}
//               />
//             )}{errors.ProjectID && (
//       <span style={errorStyle}>{errors.ProjectID}</span>
//     )}
//           </div>

//           {/* ================= PROJECT COST ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Project Cost</label>

//             <div
//               style={{
//                 ...disabledInputStyle,
//                 width: "100%",
//                 minHeight: "38px",
//               }}
//             >
//               {`₹ ${Number(data.ProjectCost || 0).toLocaleString("en-IN")}`}{" "}
//             </div>
//           </div>

//           {/* ================= IMPLEMENTING AGENCY ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Implementing Agency</label>

//             <div
//               style={{
//                 ...disabledInputStyle,
//                 width: "100%",
//                 minHeight: "38px",
//               }}
//             >
//               {data.piu ? data.piu : "--"}
//             </div>
//           </div>

//           {/* ================= GR COPY ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Project GR Copy</label>

//             <div
//               style={{
//                 ...disabledInputStyle,
//                 width: "100%",
//                 minHeight: "38px",
//               }}
//             >
//               {data.GRCopy ? (
//                 <a
//                   href={`${apiurl}/ProjectDocsImages/${data.GRCopy}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     color: "#0066cc",
//                     textDecoration: "none",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {data.GRCopy}
//                 </a>
//               ) : (
//                 "--"
//               )}
//             </div>
//           </div>

//           {/* ================= REMAINING PROJECT COST ================= */}
//           <div
//             style={{
//               width: "100%",
//               marginBottom: "12px",
//             }}
//           >
//             <label style={labelStyle}>Remaining Project Cost</label>

//             <input
//               type="text"
//               // value={dynamicRemainingProjectCost}
//               value={Number(dynamicRemainingProjectCost || 0).toLocaleString(
//                 "en-IN",
//               )}
//               readOnly
//               style={{
//                 ...disabledInputStyle,
//                 width: "100%",
//                 minHeight: "38px",
//                 border: "1px solid #999999",
//               }}
//             />
//           </div>

//           {/* ================= ESTIMATE AMOUNT ================= */}
//          {/* 10-10  */}
// <div
//   style={{
//     width: "100%",
//     marginBottom: "12px",
//   }}
// >
//   <label style={labelStyle}>Estimate Amount</label>
 
//   <div
//     style={{
//       width: "100%",
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     }}
//   >
//     <input
//       type="text"
//       placeholder="Enter Estimate Amount"
//       name="EsitmateAmount"
//       value={
//         data.EsitmateAmount !== null &&
//         data.EsitmateAmount !== undefined &&
//         data.EsitmateAmount !== ""
//           ? Number(
//               String(data.EsitmateAmount).replace(/,/g, ""),
//             ).toLocaleString("en-IN")
//           : ""
//       }
//       onChange={(e) => {
//         const value = e.target.value.replace(/,/g, "");
 
//         // Allow only numbers
//         if (/^\d*$/.test(value)) {
//           setData((prev) => ({ ...prev, EsitmateAmount: value }));
//           setErrors((prev) => ({ ...prev, EsitmateAmount: "" }));
//         }
//       }}
//       style={{
//         ...inputStyle,
//         flex: 1,
//         minWidth: 0,
//         width: "auto",
//       }}
//     />
 
//     <button
//       type="button"
//       onClick={AddinTableOperation}
//       style={{
//         width: "70px",
//         minWidth: "70px",
//         height: "38px",
//         border: "none",
//         borderRadius: "6px",
//         background: "linear-gradient(180deg,#078AD8,#0877C5)",
//         color: "#ffffff",
//         fontSize: "12px",
//         fontWeight: "700",
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <img
//         src="/ADD-White-32.png"
//         alt="Add"
//         style={{
//           width: "16px",
//           height: "16px",
//           objectFit: "contain",
//           marginRight: "5px",
//         }}
//       />
//       ADD
//     </button>
//   </div>
 
//   {errors.EsitmateAmount && (
//     <span style={errorStyle}>{errors.EsitmateAmount}</span>
//   )}
// </div>
 

//           {/* ================= EDIT BOX ================= */}
//           {editIndex && (
//             <div
//               style={{
//                 width: "100%",
//                 backgroundColor: "#ffffff",
//                 border: "1px solid #B8D8FF",
//                 borderRadius: "6px",
//                 padding: "15px",
//                 marginBottom: "15px",
//                 boxSizing: "border-box",
//               }}
//             >
//               {/* Budget Head */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "15px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <label
//                   style={{
//                     width: "28%",
//                     fontSize: "12px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Budget Head
//                 </label>

//                 <input
//                   type="text"
//                   value={editIndex.BudgetHead}
//                   disabled
//                   style={{
//                     ...inputStyle,
//                     width: "72%",
//                   }}
//                 />
//               </div>

//               {/* Estimate Amount */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "15px",
//                   marginBottom: "15px",
//                 }}
//               >
//                 <label
//                   style={{
//                     width: "28%",
//                     fontSize: "12px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Estimate Amount
//                 </label>

//                 <input
//                   type="number"
//                   value={editIndex.amount}
//                   name="amount"
//                   onChange={(e) =>
//                     setEditIndex({
//                       ...editIndex,
//                       amount: e.target.value,
//                     })
//                   }
//                   style={{
//                     ...inputStyle,
//                     width: "72%",
//                   }}
//                 />
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                 }}
//               >
//                 <button
//                   type="button"
//                   onClick={handelchangeTablre}
//                   style={{
//                     width: "70px",
//                     height: "38px",
//                     border: "none",
//                     borderRadius: "6px",
//                     background: "linear-gradient(180deg,#078AD8,#0877C5)",
//                     color: "#ffffff",
//                     fontSize: "12px",
//                     fontWeight: "700",
//                     cursor: "pointer",
//                   }}
//                 >
//                   UPDATE
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================= TABLE ================= */}
//           {tableData && tableData.length > 0 && (
//             <div
//               style={{
//                 width: "100%",
//                 marginTop: "15px",
//                 marginBottom: "10px",
//                 overflowX: "auto",
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   minWidth: "650px",
//                   backgroundColor: "#ffffff",
//                   borderCollapse: "collapse",
//                   border: "1px solid #d6dce5",
//                   boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
//                   borderRadius: "6px",
//                   overflow: "hidden",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "#E7EDF9",
//                       color: "black",
//                       fontSize: "12px",
//                       fontWeight: 600,
//                       textAlign: "center",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     <th
//                       style={{
//                         padding: "9px 8px",
//                         border: "1px solid #ffffff",
//                       }}
//                     >
//                       Year
//                     </th>

//                     <th
//                       style={{
//                         padding: "9px 8px",
//                         border: "1px solid #ffffff",
//                       }}
//                     >
//                       Budget Head
//                     </th>

//                     <th
//                       style={{
//                         padding: "9px 8px",
//                         border: "1px solid #ffffff",
//                       }}
//                     >
//                       Amount
//                     </th>

//                     <th
//                       style={{
//                         padding: "9px 8px",
//                         border: "1px solid #ffffff",
//                       }}
//                     >
//                       Date
//                     </th>

//                     <th
//                       style={{
//                         padding: "9px 8px",
//                         border: "1px solid #ffffff",
//                       }}
//                     >
//                       Action
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {tableData.map((val, index) => (
//                     <tr
//                       key={index}
//                       style={{
//                         backgroundColor: index % 2 === 0 ? "White" : "#E5F4FB",
//                         fontSize: "12px",
//                         textAlign: "center",
//                       }}
//                     >
//                       <td
//                         style={{
//                           padding: "8px",
//                           border: "1px solid #d6dce5",
//                         }}
//                       >
//                         {val.year}
//                       </td>

//                       <td
//                         style={{
//                           padding: "8px",
//                           border: "1px solid #d6dce5",
//                           textAlign: "center",
//                         }}
//                       >
//                         {val.BudgetHead}
//                       </td>

//                       <td
//                         style={{
//                           padding: "8px",
//                           border: "1px solid #d6dce5",
//                           fontWeight: 600,
//                         }}
//                       >
//                         {Number(val.amount || 0).toLocaleString("en-IN")}
//                       </td>

//                       <td
//                         style={{
//                           padding: "8px",
//                           border: "1px solid #d6dce5",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {new Date(val.currentDate).toLocaleString()}
//                       </td>

//                       <td
//                         style={{
//                           padding: "8px",
//                           border: "1px solid #d6dce5",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             gap: "6px",
//                           }}
//                         >
//                           {/* EDIT */}
//                           <button
//                             type="button"
//                             onClick={(e) => handleEdit(e, index)}
//                             style={{
//                               height: "32px",
//                               padding: "4px 9px",
//                               backgroundColor: "#ffffff",
//                               border: "1px solid #044c92",
//                               color: "#044c92",
//                               borderRadius: "5px",
//                               fontWeight: "600",
//                               fontSize: "11px",
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "4px",
//                               cursor: "pointer",
//                             }}
//                           >
//                             <img
//                               src={EditIcon}
//                               alt="Edit"
//                               style={{
//                                 width: "17px",
//                                 height: "17px",
//                               }}
//                             />
//                             Edit
//                           </button>

//                           {/* DELETE */}
//                           <button
//                             type="button"
//                             onClick={(e) => handleDelete(e, index)}
//                             style={{
//                               height: "32px",
//                               padding: "4px 9px",
//                               backgroundColor: "#ffffff",
//                               border: "1px solid #ee5d50",
//                               color: "#ee5d50",
//                               borderRadius: "5px",
//                               fontWeight: "600",
//                               fontSize: "11px",
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "4px",
//                               cursor: "pointer",
//                             }}
//                           >
//                             <img
//                               src={DeleteIcon}
//                               alt="Delete"
//                               style={{
//                                 width: "17px",
//                                 height: "17px",
//                               }}
//                             />
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </form>

//         {/* ================= SUBMIT / CANCEL ================= */}
//         <div
//           style={{
//             width: "100%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             gap: "15px",
//             marginTop: "20px",
//           }}
//         >
//           {/* SUBMIT */}
//           <button
//             type="submit"
//             disabled={loading}
//             onClick={handleSubmit}
//             style={{
//               width: "90px",
//               height: "38px",
//               border: "none",
//               borderRadius: "6px",
//               backgroundColor: "#39B54A",
//               color: "#ffffff",
//               fontSize: "12px",
//               fontWeight: "700",
//               cursor: loading ? "not-allowed" : "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "5px",
//               opacity: loading ? 0.7 : 1,
//             }}
//           >
//             <img
//               src={submit}
//               alt="Submit"
//               style={{
//                 width: "17px",
//                 height: "17px",
//                 objectFit: "contain",
//               }}
//             />

//             {loading
//               ? isEdit
//                 ? "Updating..."
//                 : "Submitting..."
//               : isEdit
//                 ? "Update"
//                 : "Submit"}
//           </button>

//           {/* CANCEL */}
//           <button
//             type="button"
//             onClick={() => {
//               if (onCancle) {
//                 onCancle();
//               }
//             }}
//             style={{
//               width: "90px",
//               height: "38px",
//               border: "none",
//               borderRadius: "6px",
//               backgroundColor: "#f85f54",
//               color: "#ffffff",
//               fontSize: "12px",
//               fontWeight: "700",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "5px",
//             }}
//           >
//             <img
//               src={Cancel32}
//               alt="Cancel"
//               style={{
//                 width: "17px",
//                 height: "17px",
//                 objectFit: "contain",
//               }}
//             />
//             Cancel
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BudgetEstimation;



import React, { useContext, useEffect, useState, useRef } from "react";
import "./BudgetEstimation.css";
import { useLocation, useNavigate } from "react-router-dom";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import Select from "react-select";
import {
  ProjectCreation64,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";
const BudgetEstimation = ({
  isEdit = false,
  BudgetEstimationData,
  onSuccess,
  onCancle,
}) => {
  const operation = useContext(Application);
  const [totalEstimationAmount, setTotalEstimationAmount] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
 const [errors, setErrors] = useState({});//09-10 error msg
  const { GetProjectInfo, GetBudgetHeadInfo, BudgetEstimation } = operation;

  const [projectId, setProjectId] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [allHeadId, setAllHeadID] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  // const [isEditing, setIsEditing] = useState(false);
  const [IsEdit, setIsEdit] = useState(null);
  const [EditBudgetEstimateId, setEditBudgetEstimateId] = useState(null);
  const [indexofediting, setIndexofEditing] = useState(null);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [remainingAmount, setRemainingAmount] = useState(0); // State for remaining amount
  const [tableData, setTableData] = useState([]);
  const [dynamicRemainingProjectCost, setDynamicRemainingProjectCost] =
    useState(0);

  const [data, setData] = useState({
    ProjectID: "",
    ProjectName: "",
    ProjectCost: "0",
    piu: "",
    GRCopy: "",
    FinancialYear: "",
    BudgetHeadID: "",
    BudgetHeadName: "",
    BudgetHeadType: "",
    ObjectCode: "",
    EsitmateAmount: null,
    UsedAmount: 0,
  });

  useEffect(() => {
    if (isEdit && BudgetEstimationData) {
      console.log("BudgetEstimationData for eidt:", BudgetEstimationData);

      setData({
        ProjectID: BudgetEstimationData.ProjectID,
        ProjectName: BudgetEstimationData.ProjectName || "",
        ProjectCost: BudgetEstimationData.ProjectCost || "",
        piu: BudgetEstimationData.piu || "",
        Date: BudgetEstimationData.Date
          ? BudgetEstimationData.Date.slice(0, 16)
          : "",
        GRCopy: BudgetEstimationData.GRCopy || "",
        FinancialYear: BudgetEstimationData.Year || "",
        BudgetHeadID: BudgetEstimationData.BudgetID,
        BudgetHeadName: BudgetEstimationData.BudgetHead || "",
        BudgetHeadType: BudgetEstimationData.BudgetHeadType || "",
        ObjectCode: BudgetEstimationData.ObjectCode || "",
        EsitmateAmount: BudgetEstimationData.EsitmateAmount || "",
        UsedAmount: BudgetEstimationData.UsedAmount || "",
      });
    }
  }, [isEdit, BudgetEstimationData]);
 

  useEffect(() => {
    if (
      isEdit &&
      BudgetEstimationData &&
      projectId.length > 0 &&
      allHeadId.length > 0
    ) {
      HeadIDFetchOperation(BudgetEstimationData.ProjectID, "ProjectId");

      HeadIDFetchOperation(BudgetEstimationData.BudgetID, "HeadID");
    }
  }, [isEdit, BudgetEstimationData, projectId.length, allHeadId.length]);
  

// 09-10 error msg 
 const HandleChangeData = (e) => {
  const { name, value } = e.target;
 
  if (name === "EsitmateAmount") {
    if (parseFloat(value) < 0) {
      setErrors((prev) => ({
        ...prev,
        EsitmateAmount: "Estimate Amount cannot be negative",
      }));
      return;
    }
 
    if (
      parseFloat(value) > dynamicRemainingProjectCost &&
      value !== ""
    ) {
      setErrors((prev) => ({
        ...prev,
        EsitmateAmount:
          "Estimate Amount cannot exceed the Remaining Project Cost",
      }));
      return;
    }
  }
 
  setData((prev) => ({
    ...prev,
    [name]: value,
  }));
 
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();

// 09-10 erroor msg
const newErrors = {};
 
  if (!data.FinancialYear || data.FinancialYear === "null") {
    newErrors.FinancialYear = "Financial Year is required";
  }
 
  if (!data.BudgetHeadID || data.BudgetHeadID === "null") {
    newErrors.BudgetHeadID = "Budget Head is required";
  }
 
  if (!data.ProjectID || data.ProjectID === "null") {
    newErrors.ProjectID = "Project Name is required";
  }
 
  if (!data.ProjectCost || Number(data.ProjectCost) <= 0) {
    newErrors.ProjectCost = "Project Cost is required";
  }
 
  if (!data.piu || data.piu.trim() === "") {
    newErrors.piu = "Implementing Agency is required";
  }
 
  if (!data.GRCopy || data.GRCopy.trim() === "") {
    newErrors.GRCopy = "Project GR Copy is required";
  }
 
//10/10
   if (tableData.length === 0 && !(Number(data.EsitmateAmount) > 0)) {
    newErrors.EsitmateAmount = "Estimate Amount is required";
  }
  if (
    dynamicRemainingProjectCost === null ||
    dynamicRemainingProjectCost === undefined
  ) {
    newErrors.RemainingProjectCost = "Remaining Project Cost is required";
  }
 
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }
 
  setErrors({});
  // setLoading(true);
 

    if (!tableData || tableData.length === 0) {
      alert("Please Add Your Estimate Amount.");
      return;
    }

    // ✅ Make sure every row has a Budget Head
    const missingBudgetHead = tableData.some((item) => !item.BudgetHead);

    if (missingBudgetHead) {
      alert("Please select Budget Head.");
      return;
    }

    setLoading(true);
    // setLoading(true);

    try {
      const payload = {
        ...(isEdit
          ? {
              type: "updateBudgetEstimationData",
              ID: BudgetEstimationData.ID,
            }
          : {
              type: "createBudgetEstimationData",
            }),
        ProjectID: data.ProjectID, // selected project ID
        ProjectName: data.ProjectName,
        FinancialYear: data.FinancialYear,
        ObjectCode: data.ObjectCode,
        Estimations: tableData.map((item) => ({
          BudgetID: item.BudgetID,
          BudgetHead: item.BudgetHead,
          ObjectCode: data.ObjectCode,
          Amount: item.amount,
          Date: item.currentDate,
        })),
      };

      const res = await BudgetEstimation(payload); // ✅ send correct payload
      console.log(res);
      // alert(res.message);
      // 10-10
                alert(isEdit ? "Updated successfully" : res?.message || "Submitted successfully");

      await FetchData();
      setTableData([]);
      window.location.reload();
      setData((prev) => ({ ...prev, EsitmateAmount: null }));
      setRemainingAmount(0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const FetchData = async () => {
    try {
      let res = await GetProjectInfo("null", "all");
      let res1 = await GetBudgetHeadInfo("null", "all");
      const projects = await GetProjectInfo("null", "all");

      const heads = await GetBudgetHeadInfo("null", "all");
      setProjectId(res);
      setAllHeadID(res1);
      setHeadID(res1);
      setProjectId(projects || []);

      setAllHeadID(heads || []);

      setHeadID(heads || []);
      setFilteredProjects(projects || []);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    // initial remaining = ProjectCost - UsedAmount from DB
    const initialRemainingCost =
      parseFloat(data.ProjectCost || 0) - parseFloat(data.UsedAmount || 0);

    // total of all estimated amounts in the table for this project
    const totalAmountInTableForProject = tableData.reduce((total, item) => {
      if (item.projectId === data.ProjectID) {
        return total + Number(item.amount);
      }

      return total;
    }, 0);
    console.log("totalamountestimate", totalAmountInTableForProject); //this is we will show in workorder
    // update remaining project cost
    setDynamicRemainingProjectCost(
      initialRemainingCost - totalAmountInTableForProject,
    );

    // update total estimation amount
    setTotalEstimationAmount(
      totalAmountInTableForProject + (data.UsedAmount || 0),
    );
  }, [tableData, data.ProjectID, data.ProjectCost, data.UsedAmount]);

  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype == "ProjectId") {
        let res1 = await GetProjectInfo(ID, "id");
        if (!res1 || res1.length === 0) {
          setHeadID([]);
          return;
        }
        console.log("Project ID ingo :: ", res1);
        let projectData = res1[0];
        const projectHeadIDs = [
          ...new Set(
            res1
              .map(
                (item) =>
                  item.ProjectHeadID || item.BudgetHeadID || item.HeadID,
              )
              .filter(Boolean)
              .map((id) => String(id)),
          ),
        ];

        const relatedHeads = allHeadId.filter((head) =>
          projectHeadIDs.includes(String(head.HeadID)),
        );

        console.log("Project Head IDs:", projectHeadIDs);
        console.log("Related Heads:", relatedHeads);

        setHeadID(relatedHeads);
      
        console.log("Related Heads:", relatedHeads);

        // setHeadID(relatedHeads);
        console.log("project data i sleected ", projectData);

        // let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
        // console.log("Head related to project ", apple)
        // setRelatedHeadID(apple);

        setData((prev) => ({
          ...prev,
          FinancialYear: projectData.FinancialYear || prev.FinancialYear,
          ProjectName: projectData.ProjectName || " ",
          ProjectID: projectData.ProjectId || " ",
          ProjectCost: projectData.ProjectCost || " ",
          piu: projectData.PIU || " ",
          GRCopy: projectData.GRCopy || " ",
          UsedAmount: projectData.UsedAmount || 0,
        }));
      } else if (IDtype == "HeadID") {
        let res1 = await GetBudgetHeadInfo(ID, "id");
        if (!res1 || res1.length === 0) {
          console.log("Budget Head not found");
          return;
        }
        console.log("Head ID info ", res1);
        let HeadData = res1[0];
        setData((prev) => ({
          ...prev,
          BudgetHeadID: HeadData.HeadID || " ",
          BudgetHeadName: HeadData.HeadName || " ",
          BudgetHeadType: HeadData.HeadType || " ",
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchData();
  }, []);

  const AddinTableOperation = (e) => {
    e.preventDefault();

    // if (!tableData || tableData.length === 0) {
    //   alert("Please select Budget Head.");
    //   return;
    // }

    // // ✅ Make sure every row has a Budget Head
    // const missingBudgetHead = tableData.some((item) => !item.BudgetHead);

    // if (missingBudgetHead) {
    //   alert("Please select Budget Head.");
    //   return;
    // }

    if (!data.BudgetHeadID) {
      alert("Please select Budget Head.");
      return;
    }

    // setLoading(true);
    const newAmount = parseFloat(data.EsitmateAmount);

    if (!newAmount || newAmount < 0) {
      alert("Please enter a valid Estimate Amount.");
      return;
    }

    if (newAmount > dynamicRemainingProjectCost) {
      alert(
        "Adding this amount would exceed the Remaining Project Cost. Please adjust your estimate.",
      );
      return;
    }

    let obj = {
      projectId: data.ProjectID,
      projectName: data.ProjectName,
      year: data.FinancialYear,
      BudgetID: data.BudgetHeadID,
      BudgetHead: data.BudgetHeadName,
      amount: newAmount,
      currentDate: new Date().toISOString(),
    };

    setTableData((prev) => [...prev, obj]);

    // clear estimate amount for next entry
    setData((prev) => ({ ...prev, EsitmateAmount: "" }));
  };

  console.log("table Data :: ", tableData);

  const handleEdit = (e, index) => {
    e.preventDefault();
    const item = tableData[index];
    console.log("table i selected :: ", item);
    setEditIndex(item);
    setIndexofEditing(index);
  };

  const handleDelete = (e, index) => {
    e.preventDefault();
    const updated = tableData.filter((_, i) => i !== index);
    setTableData(updated);
  };

  const handelchangeTablre = (e) => {
    e.preventDefault();
    const updatedData = [...tableData];
    updatedData[indexofediting] = editIndex;
    setTableData(updatedData);
    console.log("Editted Index :: ", editIndex);
    setEditIndex(null);
    setIndexofEditing(null);
  };

  const handleYearChange = (e) => {
    const year = e.target.value;
    setData({ ...data, FinancialYear: year, ProjectID: "", ProjectName: "" });
    setFilteredProjects([]); // reset
  };

  const handleHeadChange = async (e) => {
    const headID = e.target.value;

    console.log("SELECTED HEAD ID:", headID);

    // ================= CLEAR BUDGET HEAD =================
    if (!headID || headID === "null") {
      setData((prev) => ({
        ...prev,
        BudgetHeadID: "",
        BudgetHeadName: "",
        BudgetHeadType: "",
        ObjectCode: "",
        ProjectID: "",
        ProjectName: "",
        ProjectCost: "",
        piu: "",
        GRCopy: "",
        UsedAmount: 0,
      }));

      setFilteredProjects(projectId || []);
      setHeadID(allHeadId || []);

      return;
    }

    try {
      // =====================================================
      // 1. GET SELECTED BUDGET HEAD
      // =====================================================
      const headRes = await GetBudgetHeadInfo(headID, "id");

      if (!headRes || headRes.length === 0) {
        console.log("Budget Head not found");

        setFilteredProjects([]);

        return;
      }

      const HeadData = headRes[0];

      console.log("SELECTED HEAD:", HeadData);

      // =====================================================
      // 2. SET SELECTED BUDGET HEAD DATA
      // =====================================================
      setData((prev) => ({
        ...prev,

        BudgetHeadID: HeadData.HeadID || headID,

        BudgetHeadName: HeadData.HeadName || "",

        BudgetHeadType: HeadData.HeadType || "",

        ObjectCode: HeadData.objectCode || "",

        // Clear previous project
        ProjectID: "",
        ProjectName: "",
        ProjectCost: "",
        piu: "",
        GRCopy: "",
        UsedAmount: 0,
      }));

      // Clear old table rows when Budget Head changes
      setTableData([]);

      // =====================================================
      // 3. GET ALL BUDGET PROJECTS
      // =====================================================
      const projectRes = await GetProjectInfo("null", "BudgetProjects");

      console.log("ALL PROJECTS:", projectRes);

      if (!projectRes || projectRes.length === 0) {
        setFilteredProjects([]);
        return;
      }

      // =====================================================
      // 4. CHECK EVERY PROJECT
      // =====================================================
      const matchedProjects = [];

      for (const project of projectRes) {
        if (!project.ProjectId) {
          continue;
        }

        // Get complete project details
        const projectDetails = await GetProjectInfo(project.ProjectId, "id");

        console.log("PROJECT DETAILS:", project.ProjectName, projectDetails);

        if (!projectDetails || projectDetails.length === 0) {
          continue;
        }

        // ===================================================
        // 5. CHECK PROJECT'S BUDGET HEAD ID
        // ===================================================
        const matched = projectDetails.some((item) => {
          const projectHeadID = String(
            item.ProjectHeadID || item.BudgetHeadID || item.HeadID || "",
          );

          console.log("Checking:", project.ProjectName, {
            projectHeadID,
            selectedHeadID: String(headID),
          });

          return projectHeadID === String(headID);
        });

        // ===================================================
        // 6. ADD MATCHING PROJECT
        // ===================================================
        if (matched) {
          // Financial year filtering
          if (
            !data.FinancialYear ||
            project.FinancialYear === data.FinancialYear
          ) {
            matchedProjects.push(project);
          }
        }
      }

      // =====================================================
      // 7. REMOVE DUPLICATE PROJECTS
      // =====================================================
      const uniqueProjects = [
        ...new Map(
          matchedProjects.map((project) => [project.ProjectId, project]),
        ).values(),
      ];

      console.log("ALL PROJECTS MATCHING HEAD:", uniqueProjects);

      // =====================================================
      // 8. SHOW FILTERED PROJECTS
      // =====================================================
      setFilteredProjects(uniqueProjects);
    } catch (error) {
      console.error("Error fetching projects by Budget Head:", error);

      setFilteredProjects([]);
    }
  };

  const rowStyle = {
    width: "100%",

    display: "flex",
    alignItems: "center",

    marginBottom: "12px",
  };

  //30/10
  const labelStyle = {
    width: "28%",
    fontSize: "14px",
    fontWeight: "700",
   whiteSpace:"nowrap",
    color: "#111111",

    flexShrink: 0,
  };

  // 09-10
  const inputStyle = {
    width: "95%",
    height: "38px",
 
    padding: "8px 12px",
 
    border: "1px solid #999999",
    borderRadius: "6px",
 
    backgroundColor: "#ffffff",
 
    fontSize: "12px",
 
    boxSizing: "border-box",
 
    outline: "none"
  };
 
  // -09-10 error msg
 const disabledInputStyle = {
  width: "95%",
  minHeight: "38px",
  display: "flex",
  alignItems: "center",
  padding: "8px 12px",
  border: "1px solid #999999",
  borderRadius: "6px",
  backgroundColor: "#C8D9E8",
  color: "#333333",
  fontSize: "11px",
  boxSizing: "border-box",
  overflow: "hidden"
};
const errorStyle = {
  color: "#dc3545",
  fontSize: "12px",
  marginTop: "3px",
  display: "block",
  fontWeight: "500",
  lineHeight: "14px",
  height: "14px",       // important
  visibility: "visible",
};

  
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "90vh",
          minHeight: "calc(100vh - 80px)",
          backgroundColor: "#ffffff",
          // padding: "15px 25px 30px",
          padding:"40px",
          boxSizing: "border-box",
          fontFamily: "Inter, sans-serif",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* ================= PAGE TITLE ================= */}
        <div
          style={{
             display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          background: "transparent",
          padding: "0",
          // marginRight: "20px",
          // marginLeft: "-30px",
          boxShadow: "none",
          width: "100%",
          marginBottom: "18px",
          }}
        >
          <img
            src={ProjectCreation64}
            alt="Budget Estimation"
            style={{
              //30/10
              width: "24px",
              height: "24px",
              objectFit: "contain",
            }}
          />

          <h5
            style={{
               margin: 0,
            color: "black",
            fontWeight: 700,
            //30/10
            fontSize: "22px",
            lineHeight: "1.2",
            }}
          >
            {isEdit ? "Update Budget Estimate" : "Add Budget Estimation"}
          </h5>
        </div>

        {/* ================= MAIN FORM ================= */}
        {/* //30/10 */}
<div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "1000px", margin: "0 auto", width:"100%" }}>
       {/* //30/10 */}
        <form
          onSubmit={handleSubmit}
           style={{
        backgroundColor: "#EEF2F8",
        border: "1px solid #dde3ee",
        borderRadius: "10px",
        padding: "25px 28px",
       
        gap: "18px 24px",
      }}
        >
          {/* ================= FINANCIAL YEAR ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Financial Year</label>

            <Select
              options={[
                {
                  value: "2024-2025",
                  label: "2024 - 2025",
                },
                {
                  value: "2025-2026",
                  label: "2025 - 2026",
                },
                {
                  value: "2026-2027",
                  label: "2026 - 2027",
                },
              ]}
              value={
                data.FinancialYear
                  ? {
                      value: data.FinancialYear,
                      label: data.FinancialYear.replace("-", " - "),
                    }
                  : null
              }
              onChange={(selected) =>
                HandleChangeData({
                  target: {
                    name: "FinancialYear",
                    value: selected ? selected.value : "",
                  },
                })
              }
              placeholder="Choose Financial Year"
              isSearchable
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
  height: "40px",
  borderRadius: "10px",
  border: "1px solid #c7c0c0",
  fontSize: "12px",
  width: "100%",
  boxShadow: "none",
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "38px",
                  padding: "0 12px",
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "38px",
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: "13px",
                }),
                option: (base) => ({
                  ...base,
                  fontSize: "13px",
                }),
              }}
            />
            {errors.FinancialYear && (
      <span style={errorStyle}>
        {errors.FinancialYear}
      </span>
    )}
          </div>

          {/* ================= BUDGET HEAD ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>
              Budget Head <span style={{ color: "red" }}>*</span>
            </label>

            <Select
              options={HeadId.map((val) => ({
                value: val.HeadID,
                label: val.HeadName || "",
              }))}
              value={
                HeadId.map((val) => ({
                  value: val.HeadID,
                  label: val.HeadName || "",
                })).find(
                  (option) =>
                    String(option.value) === String(data.BudgetHeadID),
                ) || null
              }
              onChange={(selected) => {
                handleHeadChange({
                  target: {
                    name: "BudgetHeadID",
                    value: selected ? selected.value : "",
                  },
                });
              }}
              placeholder="Choose Budget Head"
              isSearchable
              isClearable
              noOptionsMessage={() => "No budget head found"}
              styles={{
                control: (base) => ({
                  ...base,
                   minHeight: "40px",
  height: "40px",
  borderRadius: "10px",
  border: "1px solid #c7c0c0",
  fontSize: "12px",
  width: "100%",
  boxShadow: "none",
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "38px",
                  padding: "0 12px",
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "38px",
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: "13px",
                }),
                option: (base) => ({
                  ...base,
                  fontSize: "13px",
                }),
              }}
            />  {errors.BudgetHeadID && (
    <span style={errorStyle}>
      {errors.BudgetHeadID}
    </span>
  )}
 
          </div>

          {/* ================= PROJECT NAME ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Project Name</label>

            {!isEdit ? (
              <Select
                options={filteredProjects.map((val) => ({
                  value: val.ProjectId,
                  label: val.ProjectName,
                }))}
                value={
                  filteredProjects
                    .map((val) => ({
                      value: val.ProjectId,
                      label: val.ProjectName,
                    }))
                    .find(
                      (option) =>
                        String(option.value) === String(data.ProjectID),
                    ) || null
                }
                onChange={async (selected) => {
                  const selectedProjectID = selected ? selected.value : "";

                  /* ================= PROJECT CLEARED ================= */
                  if (!selectedProjectID) {
                    setData((prev) => ({
                      ...prev,
                      ProjectID: "",
                      ProjectName: "",
                      ProjectCost: "",
                      piu: "",
                      GRCopy: "",
                      UsedAmount: 0,
                      BudgetHeadID: "",
                      BudgetHeadName: "",
                      BudgetHeadType: "",
                      ObjectCode: "",
                    }));

                    setFilteredProjects(projectId || []);
                    setHeadID(allHeadId || []);

                    return;
                  }

                  /* ================= PROJECT SELECTED ================= */
                  try {
                    const projectDetails = await GetProjectInfo(
                      selectedProjectID,
                      "id",
                    );

                    if (!projectDetails || projectDetails.length === 0) {
                      return;
                    }

                    const projectData = projectDetails[0];

                    console.log("Selected Project Details:", projectData);

                    /* ================= FIND PROJECT HEAD ================= */
                    const projectHeadID =
                      projectData.ProjectHeadID ||
                      projectData.BudgetHeadID ||
                      projectData.HeadID;

                    let relatedHeads = [];

                    if (projectHeadID) {
                      relatedHeads = allHeadId.filter(
                        (head) => String(head.HeadID) === String(projectHeadID),
                      );
                    }

                    console.log(
                      "Heads related to selected project:",
                      relatedHeads,
                    );

                    setHeadID(relatedHeads);

                    /* ================= SET PROJECT DATA ================= */
                    setData((prev) => ({
                      ...prev,

                      ProjectID: projectData.ProjectId || selectedProjectID,

                      ProjectName: projectData.ProjectName || "",

                      FinancialYear:
                        projectData.FinancialYear || prev.FinancialYear,

                      ProjectCost: projectData.ProjectCost || 0,

                      piu: projectData.PIU || "",

                      GRCopy: projectData.GRCopy || "",

                      UsedAmount: projectData.UsedAmount || 0,

                      BudgetHeadID: projectHeadID || "",

                      BudgetHeadName:
                        relatedHeads.length > 0 ? relatedHeads[0].HeadName : "",

                      BudgetHeadType:
                        relatedHeads.length > 0 ? relatedHeads[0].HeadType : "",

                      ObjectCode:
                        relatedHeads.length > 0
                          ? relatedHeads[0].objectCode
                          : "",
                    }));

                    HeadIDFetchOperation(selectedProjectID, "ProjectId");
                  } catch (error) {
                    console.error("Error fetching selected project:", error);
                  }
                }}
                placeholder="Choose Project"
                isSearchable
                isClearable
                noOptionsMessage={() => "No project found"}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "40px",
  height: "40px",
  borderRadius: "10px",
  border: "1px solid #c7c0c0",
  fontSize: "12px",
  width: "100%",
  boxShadow: "none",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "38px",
                    padding: "0 12px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "38px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "13px",
                  }),
                  option: (base) => ({
                    ...base,
                    fontSize: "13px",
                  }),
                }}
              />
 
            ) : (
              <input
                type="text"
                value={data.ProjectName || ""}
                readOnly
                style={{
                  ...inputStyle,
                  width: "100%",
                }}
              />
            )}{errors.ProjectID && (
      <span style={errorStyle}>{errors.ProjectID}</span>
    )}
          </div>

          {/* ================= PROJECT COST ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Project Cost</label>

            <div
              style={{
                ...disabledInputStyle,
                width: "100%",
                minHeight: "38px",
              }}
            >
              {`₹ ${Number(data.ProjectCost || 0).toLocaleString("en-IN")}`}{" "}
            </div>
          </div>

          {/* ================= IMPLEMENTING AGENCY ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Implementing Agency</label>

            <div
              style={{
                ...disabledInputStyle,
                width: "100%",
                minHeight: "38px",
              }}
            >
              {data.piu ? data.piu : "--"}
            </div>
          </div>

          {/* ================= GR COPY ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Project GR Copy</label>

            <div
              style={{
                ...disabledInputStyle,
                width: "100%",
                minHeight: "38px",
              }}
            >
              {data.GRCopy ? (
                <a
                  href={`${apiurl}/ProjectDocsImages/${data.GRCopy}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#0066cc",
                    textDecoration: "none",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.GRCopy}
                </a>
              ) : (
                "--"
              )}
            </div>
          </div>

          {/* ================= REMAINING PROJECT COST ================= */}
          <div
            style={{
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <label style={labelStyle}>Remaining Project Cost</label>

            <input
              type="text"
              // value={dynamicRemainingProjectCost}
              value={Number(dynamicRemainingProjectCost || 0).toLocaleString(
                "en-IN",
              )}
              readOnly
              style={{
                ...disabledInputStyle,
                width: "100%",
                minHeight: "38px",
                border: "1px solid #999999",
              }}
            />
          </div>

          {/* ================= ESTIMATE AMOUNT ================= */}
          {/* <div style={rowStyle}
          >
                     <label style={labelStyle}>Estimate Amount</label>

            
             <div style={{ width: "70%", position: "relative" }}>

            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Enter Estimate Amount"
                name="EsitmateAmount"
                //  value={data.EsitmateAmount ?? ""}
                value={
                  data.EsitmateAmount !== null &&
                  data.EsitmateAmount !== undefined &&
                  data.EsitmateAmount !== ""
                    ? Number(
                        String(data.EsitmateAmount).replace(/,/g, ""),
                      ).toLocaleString("en-IN")
                    : ""
                }
                // onChange={HandleChangeData}
                onChange={(e) => {
                  const value = e.target.value.replace(/,/g, "");

                  // Allow only numbers
                  if (/^\d*$/.test(value)) {
                    setData({
                      ...data,
                      EsitmateAmount: value,
                    });
                  }
                }}
                style={{
                  ...inputStyle,
                  width: "100%",
                  // flex: 1,
                  // minWidth: 0,
                }}
              /> <div
      style={{
        position: "absolute",
        left: "0",
        top: "41px",
      }}
    >
      
    </div>

              <button
                type="button"
                onClick={AddinTableOperation}
                style={{
                  width: "70px",
                  minWidth: "70px",
                  height: "38px",
                  border: "none",
                  borderRadius: "6px",
                  background: "linear-gradient(180deg,#078AD8,#0877C5)",
                  color: "#ffffff",
                  fontSize: "12px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              ><img
  src="/ADD-White-32.png"
  alt="Add"
  style={{
    width: "16px",
    height: "16px",
    objectFit: "contain",
    marginRight:"5px"
  }}
/>
                ADD
              </button>
            </div>
          </div></div> */}
{/* 10-10  */}
<div
  style={{
    width: "100%",
    marginBottom: "12px",
  }}
>
  <label style={labelStyle}>Estimate Amount</label>
 
  <div
    style={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    <input
      type="text"
      placeholder="Enter Estimate Amount"
      name="EsitmateAmount"
      value={
        data.EsitmateAmount !== null &&
        data.EsitmateAmount !== undefined &&
        data.EsitmateAmount !== ""
          ? Number(
              String(data.EsitmateAmount).replace(/,/g, ""),
            ).toLocaleString("en-IN")
          : ""
      }
      onChange={(e) => {
        const value = e.target.value.replace(/,/g, "");
 
        // Allow only numbers
        if (/^\d*$/.test(value)) {
          setData((prev) => ({ ...prev, EsitmateAmount: value }));
          setErrors((prev) => ({ ...prev, EsitmateAmount: "" }));
        }
      }}
      style={{
        ...inputStyle,
        flex: 1,
        minWidth: 0,
        width: "auto",
      }}
    />
 
    <button
      type="button"
      onClick={AddinTableOperation}
      style={{
        width: "70px",
        minWidth: "70px",
        height: "38px",
        border: "none",
        borderRadius: "6px",
        background: "linear-gradient(180deg,#078AD8,#0877C5)",
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: "700",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src="/ADD-White-32.png"
        alt="Add"
        style={{
          width: "16px",
          height: "16px",
          objectFit: "contain",
          marginRight: "5px",
        }}
      />
      ADD
    </button>
  </div>
 
  {errors.EsitmateAmount && (
    <span style={errorStyle}>{errors.EsitmateAmount}</span>
  )}
</div>
 
          {/* ================= EDIT BOX ================= */}
          {editIndex && (
            <div
              style={{
                width: "100%",
                backgroundColor: "#ffffff",
                border: "1px solid #B8D8FF",
                borderRadius: "6px",
                padding: "15px",
                marginBottom: "15px",
                boxSizing: "border-box",
              }}
            >
              {/* Budget Head */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  marginBottom: "12px",
                }}
              >
                <label
                  style={{
                    width: "28%",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  Budget Head
                </label>

                <input
                  type="text"
                  value={editIndex.BudgetHead}
                  disabled
                  style={{
                    ...inputStyle,
                    width: "72%",
                  }}
                />
              </div>

              {/* Estimate Amount */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  marginBottom: "15px",
                }}
              >
                <label
                  style={{
                    width: "28%",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  Estimate Amount
                </label>

                <input
                  type="number"
                  value={editIndex.amount}
                  name="amount"
                  onChange={(e) =>
                    setEditIndex({
                      ...editIndex,
                      amount: e.target.value,
                    })
                  }
                  style={{
                    ...inputStyle,
                    width: "72%",
                  }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  onClick={handelchangeTablre}
                  style={{
                    width: "70px",
                    height: "38px",
                    border: "none",
                    borderRadius: "6px",
                    background: "linear-gradient(180deg,#078AD8,#0877C5)",
                    color: "#ffffff",
                    fontSize: "12px",
                    fontWeight: "700",
                    cursor: "pointer",
                  }}
                >
                  UPDATE
                </button>
              </div>
            </div>
          )}

          {/* ================= TABLE ================= */}
          {tableData && tableData.length > 0 && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                marginBottom: "10px",
                overflowX: "auto",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "650px",
                  backgroundColor: "#ffffff",
                  borderCollapse: "collapse",
                  border: "1px solid #d6dce5",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  borderRadius: "6px",
                  overflow: "hidden",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#E7EDF9",
                      color: "black",
                      fontSize: "12px",
                      fontWeight: 600,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th
                      style={{
                        padding: "9px 8px",
                        border: "1px solid #ffffff",
                      }}
                    >
                      Year
                    </th>

                    <th
                      style={{
                        padding: "9px 8px",
                        border: "1px solid #ffffff",
                      }}
                    >
                      Budget Head
                    </th>

                    <th
                      style={{
                        padding: "9px 8px",
                        border: "1px solid #ffffff",
                      }}
                    >
                      Amount
                    </th>

                    <th
                      style={{
                        padding: "9px 8px",
                        border: "1px solid #ffffff",
                      }}
                    >
                      Date
                    </th>

                    <th
                      style={{
                        padding: "9px 8px",
                        border: "1px solid #ffffff",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((val, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "White" : "#E5F4FB",
                        fontSize: "12px",
                        textAlign: "center",
                      }}
                    >
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #d6dce5",
                        }}
                      >
                        {val.year}
                      </td>

                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #d6dce5",
                          textAlign: "center",
                        }}
                      >
                        {val.BudgetHead}
                      </td>

                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #d6dce5",
                          fontWeight: 600,
                        }}
                      >
                        {Number(val.amount || 0).toLocaleString("en-IN")}
                      </td>

                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #d6dce5",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(val.currentDate).toLocaleString()}
                      </td>

                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #d6dce5",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          {/* EDIT */}
                          <button
                            type="button"
                            onClick={(e) => handleEdit(e, index)}
                            style={{
                              height: "32px",
                              padding: "4px 9px",
                              backgroundColor: "#ffffff",
                              border: "1px solid #044c92",
                              color: "#044c92",
                              borderRadius: "5px",
                              fontWeight: "600",
                              fontSize: "11px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={EditIcon}
                              alt="Edit"
                              style={{
                                width: "17px",
                                height: "17px",
                              }}
                            />
                            Edit
                          </button>

                          {/* DELETE */}
                          <button
                            type="button"
                            onClick={(e) => handleDelete(e, index)}
                            style={{
                              height: "32px",
                              padding: "4px 9px",
                              backgroundColor: "#ffffff",
                              border: "1px solid #ee5d50",
                              color: "#ee5d50",
                              borderRadius: "5px",
                              fontWeight: "600",
                              fontSize: "11px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={DeleteIcon}
                              alt="Delete"
                              style={{
                                width: "17px",
                                height: "17px",
                              }}
                            />
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* //30/10 */}
           {/* ================= SUBMIT / CANCEL ================= */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
            marginTop: "20px",
          }}
        >
          {/* SUBMIT */}
          <button
            type="submit"
            disabled={loading}
            onClick={handleSubmit}
            style={{
              width: "90px",
              height: "38px",
              border: "none",
              //30/10
              borderRadius: "6px",
              backgroundColor: "#39B54A",
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: "700",
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              opacity: loading ? 0.7 : 1,
            }}
          >
            <img
              src={submit}
              alt="Submit"
              style={{
                width: "17px",
                height: "17px",
                objectFit: "contain",
              }}
            />

            {loading
              ? isEdit
                ? "Updating..."
                : "Submitting..."
              : isEdit
                ? "Update"
                : "Submit"}
          </button>

          {/* CANCEL */}
          <button
            type="button"
            onClick={() => {
              if (onCancle) {
                onCancle();
              }
            }}
            style={{
              width: "90px",
              height: "38px",
              border: "none",
              //30/10
              borderRadius: "6px",
              backgroundColor: "#f85f54",
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: "700",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <img
              src={Cancel32}
              alt="Cancel"
              style={{
                width: "17px",
                height: "17px",
                objectFit: "contain",
              }}
            />
            Cancel
          </button>
        </div>
        </form>
        
        </div>

       
      </div>
    </>
  );
};

export default BudgetEstimation;
